'use strict';

import { isFieldSame, isFieldEmpty, isValidEmail, displayInputError } from '../../_assets/abbott/js/_helper';

export default class CarerDetail {

    constructor() {
    }

    init(){

        $('.js-add-carer').on('click', function (e) {
            e.preventDefault();

            cloneCarerRow();
        });

    }

}

/* Clone markup in order to have multiple carers */
let cloneCarerRow = function(){

    let $clonedMarkup = $('.carer-details__container .markup-to-clone ')
        .clone(true);

    $clonedMarkup
        .insertBefore('.carer-details__footer')
        .slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        })
        .removeClass('markup-to-clone')
        .addClass('carer-details__row')
        .attr('data-carer-id', '')
        .on('click', '.js-remove-carer', remove);
};

/* Remove Carer */
let remove = function(){

    let $this = $(this),
        $carerWrap = $this.parent().parent(),
        institutionId = $carerWrap.data('carer-id');

    $carerWrap.slideUp({
        duration: 500,
        easing: 'easeOutExpo',
        queue: false
    });

    setTimeout(function(){
        $carerWrap.remove();
    }, 500);

};

//save details into array
let carerDetails = function () {

    let CarerDetails = [];

    $('.carer-details__row').each(function () {

        let $this = $(this),
			Id = $this.find('.CarerId').val(),
            CarerFirstName = $this.find('.CarerFirstName').val(),
            CarerLastName = $this.find('.CarerLastName').val(),
            CarerPrimaryNumber = $this.find('.CarerPrimaryNumber').val(),
            CarerSecondaryNumber = $this.find('.CarerSecondaryNumber').val(),
            CarerEmailAddress = $this.find('.CarerEmailAddress').val(),
			      CarerRelationshipToClient = $this.find('.CarerRelationshipToClient').val(),
            CarerIsPrimaryContact = $this.hasClass('first__row') ? $('#PrimaryContact').prop('checked') : false;

        let CarerDetailItem = {
			"Id": Id == '' ? null : Id,
            "FirstName": CarerFirstName,
            "LastName": CarerLastName,
            "PrimaryPhoneNumber": CarerPrimaryNumber,
            "SecondaryPhoneNumber": CarerSecondaryNumber == '' ? null : CarerSecondaryNumber,
            "EmailAddress": CarerEmailAddress == '' ? null : CarerEmailAddress,
			"RelationshipToClient": CarerRelationshipToClient,
			"PrimaryContact": CarerIsPrimaryContact
        };

        CarerDetails.push(CarerDetailItem);

    });

    return CarerDetails;

};

let isCarerFormValid = function(){
    let phoneRegEx = /^[0-9]{8,10}$/,
        _isInvalid = [];

    let $fields = $('.carer-details__container').find('input, select').filter('[required]:visible');

    $fields.each( function(){
        let $this = $(this);

        if($this.prop('required') && isFieldEmpty($this)){

            displayInputError($this, false);

            _isInvalid.push(0);
        }
        else if($this.is('.CarerPrimaryNumber') || $this.is('.CarerSecondaryNumber')){

            if(!isFieldEmpty($this) && !$this.val().match(phoneRegEx)){
                displayInputError($this, false);

                _isInvalid.push(0);
            }
        }
        else if($this.is('.CarerEmailAddress') && !isFieldEmpty($this) && !isValidEmail($this.val())){
            displayInputError($this, false);

            _isInvalid.push(0);
        }
    });

    return _isInvalid;
};


export {
    carerDetails, cloneCarerRow, isCarerFormValid
};
